import React from 'react';
import { Section } from './ui/Section';
export function PainPoints() {
  const points = ['Gastas 50, 80, 100€ al mes en productos y tu piel sigue igual — o peor', 'Pruebas activos nuevos (retinol, vitamina C, ácidos) y no sabes si están funcionando o destruyéndote la barrera', 'Tu baño está lleno de productos a medias que no sabes si conservar o tirar', 'Cada vez que ves contenido de skincare en Instagram acabas comprando algo nuevo que "necesitas urgente"', 'Tu piel tiene días buenos y días malos sin ninguna lógica aparente', 'Has gastado cientos de euros y sigues sin tener la piel que quieres'];
  return <Section variant="alt" data-id="element-150">
      <div className="max-w-3xl mx-auto" data-id="element-151">
        <h2 className="font-display md:text-4xl font-bold text-center mb-8 text-[32px] text-brand-title" data-id="element-152">
          Si tienes más de 25 años y cuidas tu piel, esto te va a sonar muy
          familiar:
        </h2>

        <div className="bg-white border border-neutral-200 rounded-2xl p-8 md:p-10 mb-12 shadow-sm" data-id="element-153">
          <ul className="space-y-5" data-id="element-154">
            {points.map((point, i) => <li key={i} className="flex items-start gap-4" data-id="element-155">
                <span className="text-red-500 text-xl mt-0.5 shrink-0" data-id="element-156">❌</span>
                <span className="font-body text-lg text-brand-text" data-id="element-157">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="text-center" data-id="element-158">
          <h3 className="font-display text-2xl md:text-3xl font-bold text-brand-title mb-6" data-id="element-159">
            ¿Sabes cuál es la verdad que nadie en la industria cosmética quiere
            que sepas?
          </h3>

          <div className="inline-block bg-white text-brand-cta font-heading font-bold px-6 py-4 rounded-xl text-xl border border-brand-cta/20 shadow-sm mb-8" data-id="element-160">
            Cuantos más productos usas, peor está tu piel.
          </div>

          <p className="font-body text-brand-text text-lg mb-6 leading-relaxed" data-id="element-161">
            No porque seas descuidada. No porque tengas "mala piel". Sino porque
            llevas años bombardeando tu piel con activos incompatibles,
            fragancias ocultas, limpiadores agresivos y rutinas de 10 pasos que
            están destruyendo tu barrera cutánea — capa a capa — cada maldita
            noche.
          </p>

          <p className="font-body text-brand-text text-lg mb-8 leading-relaxed" data-id="element-162">
            La industria cosmética gana dinero cuando tú no sabes lo que haces.
            Cada nuevo problema que aparece en tu piel es una nueva oportunidad
            de venderte algo más.
          </p>

          <p className="font-heading text-xl font-bold text-brand-cta" data-id="element-163">
            EL AUDITOR DE SKINCARE™ rompe ese ciclo. Para siempre.
          </p>
        </div>
      </div>
    </Section>;
}